/**
 * Actions for Vuex
 */

import { privateMutations } from "./mutations";

// Private actions, only available within the store itself
// const privateActions = {};

// PUblic actions, available within store and Vue Components
const publicActions = {
    UPDATE_SCROLL_POS: "UPDATE_SCROLL_POS"
};

// Actions
const actions = {
    [publicActions.UPDATE_SCROLL_POS]({ commit }) {
        commit(privateMutations.UPDATE_SCROLL_POS)
    }
};

export {
    actions as default,
    publicActions
}